import script from "./UploadSong.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadSong.vue?vue&type=script&setup=true&lang=js"

import "./UploadSong.vue?vue&type=style&index=0&id=d81de41c&scoped=true&lang=css"
script.__scopeId = "data-v-d81de41c"

export default script